import './Play.scss';

const Play: React.FC = (props) => {
  return (
    <div className="hero-play">
      <p className="hero-play__title hero-play__title_get">
        <span>Get</span>
      </p>
      <p className="hero-play__title hero-play__title_set">
        <span>Set</span>
      </p>
      <p className="hero-play__title hero-play__title_play">
        <span>Play</span>
      </p>
    </div>
  );
};

export default Play;
